import { generateSearchQuery } from '@app/utils/generateSearchQuery/generateSearchQuery'
import { Review } from '@core/domain/models/review.model'
import { RegistrationMetadata } from '@core/domain/models/reviewItemMetadata/registrationMetadata'
import { BuiltInImportSourceId } from '@core/domain/types/builtInImportSourceId'
import { ReviewItemType } from '@core/domain/types/reviewItemType.type'
import axios from 'axios'

export class ProsperoApiClient {
  async createReviewSearch(review: Review): Promise<{
    query?: string
    filters?: string
    date: string
    reviewId: number
    importSourceId: string
    items: RegistrationMetadata & { type: ReviewItemType.Registration }[]
    queryTranslation?: string
    url?: string
  }> {
    const query = generateSearchQuery(BuiltInImportSourceId.PROSPERO, review)
    const result = await this.search(query)
    return {
      query,
      date: new Date().toISOString(),
      reviewId: review.id,
      importSourceId: BuiltInImportSourceId.PROSPERO,
      items: result.map((a) => ({
        ...a,
        type: ReviewItemType.Registration,
      })),
    }
  }
  private async search(query: string): Promise<any[]> {
    let articles: RegistrationMetadata[] = []
    const url = '/live-scraper/prospero'
    const { parsedQuery, startDate, endDate } = this.parseQuery(query)
    try {
      const response = await axios.post(
        url + `?query=${parsedQuery}&startDate=${startDate}&endDate=${endDate}`,
      )
      articles = response.data.map((data: any) => this.mapToRegistration(data))
    } catch (error) {
      console.error('Error fetching records from PROSPERO API:', error)
      throw new Error(`Error fetching records from PROSPERO API`)
    }

    return articles
  }

  private parseQuery(query: string): {
    parsedQuery: string
    startDate: string
    endDate: string
  } {
    const queryRegex =
      /^(.*?) in Title AND Review status: Completed AND Date of registration: \((.*?) to (.*?)\)$/

    const queryMatch = queryRegex.exec(query)

    if (!queryMatch) {
      throw new Error('Invalid query format: missing query or date range')
    }

    const parsedQuery = queryMatch[1]
    const startDate = queryMatch[2]
    const endDate = queryMatch[3]

    console.log(
      `Parsed query: ${parsedQuery}, Start date: ${startDate}, End date: ${endDate}`,
    )

    return {
      parsedQuery,
      startDate,
      endDate,
    }
  }

  mapToRegistration(data: any): RegistrationMetadata {
    return new RegistrationMetadata({
      title: data.title,
      url: data.url,
      registrationId: data.registrationId,
      registrationDate: data.registrationDate,
    })
  }
}
